import { useCurrentUserQuery } from '@alice-financial/alice-sdk'
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@alice-financial/pretext-ui'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import * as React from 'react'
import { OrderFormDoc, TOSAcceptanceDoc } from '../../documents/DocumentsPage'
import { OrderForm } from '../../orderForm/OrderForm'
import { useOrg } from '../../organization/useOrg'

export const OrderFormStepTitle = 'Order Form'

export const OrderFormDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Review and sign your service agreement
  </Typography>
)

// Wrapper component that provides the accepterId prop to OrderForm
export const OrderFormComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery()
  const currentUser = currentUserData?.currentUser
  const org = useOrg()

  if (!org || !currentUser) return null

  // If already completed, show success message
  // @TODO: display docs
  if (org.contractSignedOn || org.isOnboarded) {
    return (
      <>
        <Typography variant="body1" color="text.secondary">
          Your order form has been successfully submitted and signed.
        </Typography>
        <List>
          <TOSAcceptanceDoc />
          <OrderFormDoc />
        </List>
      </>
    )
  }

  return (
    <>
      <Typography variant="body2" gutterBottom>
        This step creates the agreement between your company and Alice. Please review the terms, make
        selections, and sign.
      </Typography>
      <OrderForm accepterId={currentUser.id} />
    </>
  )
}

export const OrderFormInstructions = () => (
  <>
    <Typography variant="body2" gutterBottom fontWeight="bold">
      What is &ldquo;a reference and a case study&rdquo;?
    </Typography>
    <Typography variant="body2" gutterBottom>
      With your agreement, we might ask you to share your experience with Alice with other potential
      customers, or provide direct feedback to us on request.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Requirements
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Review the terms and conditions" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Agree to a 30 day onboarding timeline" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Sign the service agreement" />
      </ListItem>
    </List>

    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Key Info
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Onboarding fees waived if onboarding is completed within 30 days." />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Employee count can be an estimate" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Consider options for free months of service" />
      </ListItem>
    </List>
  </>
)
